import React from 'react';

/**
 * CheckCircleIcon
 * Renders a checkmark inside a teal gradient circle (matches Image 5).
 * Tailwind classes are used for sizing, but gradient is handled by SVG.
 */
const CheckCircleIcon: React.FC<{ size?: number | string }> = ({
  size = 34,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="inline-block align-middle"
    aria-hidden="true"
  >
    <defs>
      <linearGradient
        id="circle-gradient"
        x1="0"
        y1="0"
        x2="34"
        y2="34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--color-theme-success-gradient-from)" />
        <stop offset="1" stopColor="var(--color-theme-success-gradient-to)" />
      </linearGradient>
    </defs>
    <circle cx="17" cy="17" r="17" fill="url(#circle-gradient)" />
    <path
      d="M23.25 13.4167L15.375 21.25L11.25 17.125"
      stroke="var(--color-white)"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckCircleIcon;
